import * as CL from '@design-system/component-library';
import { useFormContext } from 'react-hook-form';
import { dsClass } from '../../../../common/constants/dsClasses';
import { addressLine2Msg, cancelMsg, postOfficeMsg, readyMsg, streetAddressMsg, t } from '../../../../common/i18n';
import { PhoneNumber, PostalCode, TextInput } from '../../../../common/react-hook-form/fields';
import type { DeliveryAddress } from '../../../../generated/api/deliveryAddress';

export interface DeliveryStepAddressProps {
  onSetAddress: (address?: DeliveryAddress) => void;
  onCancel: () => void;
  companyName?: string;
}

export const DeliveryStepAddress = ({ onSetAddress, onCancel, companyName = '' }: DeliveryStepAddressProps) => {
  const { handleSubmit, getValues } = useFormContext<DeliveryAddress>();
  const handleCancel = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onCancel();
  };

  const onSubmit = () => {
    const deliveryAddress = {
      ...getValues(),
      companyName,
    };
    onSetAddress(deliveryAddress);
  };

  const handleSetAddress = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    handleSubmit(onSubmit)(e);
  };

  return (
    <CL.Grid className={dsClass.MARGIN_TOP_4}>
      <CL.GridRow>
        <CL.GridCol colWidthXS={4} colWidthS={3} colWidthL={6}>
          <TextInput
            name="recipient"
            label={t.U9EI('Recipient Name')}
            placeholder={t.U9EI('Recipient Name')}
            required
            maxLength={140}
          />
        </CL.GridCol>
        <CL.GridCol colWidthXS={4} colWidthS={3} colWidthL={6}>
          <PhoneNumber name="phoneNumber" label={t.O5R1('Recipient Phone Number')} required />
        </CL.GridCol>
      </CL.GridRow>
      <CL.GridRow>
        <CL.GridCol colWidthXS={4} colWidthS={3} colWidthL={6}>
          <TextInput
            name="address.line1"
            label={t.DD38(streetAddressMsg)}
            placeholder={t.DD38(streetAddressMsg)}
            required
            maxLength={40}
          />
        </CL.GridCol>
        <CL.GridCol colWidthXS={4} colWidthS={3} colWidthL={6}>
          <TextInput
            name="address.line2"
            label={t.O0QI(addressLine2Msg)}
            placeholder={t.O0QI(addressLine2Msg)}
            maxLength={40}
            required={false}
            optional={true}
          />
        </CL.GridCol>
      </CL.GridRow>
      <CL.GridRow>
        <CL.GridCol colWidthXS={4} colWidthS={3} colWidthL={6}>
          <PostalCode name="address.postalCode" />
        </CL.GridCol>
        <CL.GridCol colWidthXS={4} colWidthS={3} colWidthL={6}>
          <TextInput
            name="address.postOffice"
            label={t.Z7S5(postOfficeMsg)}
            placeholder={t.Z7S5(postOfficeMsg)}
            required
            maxLength={100}
          />
        </CL.GridCol>
      </CL.GridRow>
      <CL.GridRow>
        <CL.GridCol colWidthXS={4}>
          <CL.Button type="button" onClick={handleSetAddress}>
            {t.L75K(readyMsg)}
          </CL.Button>
          <CL.Button
            type="button"
            onClick={handleCancel}
            color="secondary"
            className={`${dsClass.MARGIN_HORIZONTAL_3}`}
          >
            {t.B2V1(cancelMsg)}
          </CL.Button>
        </CL.GridCol>
      </CL.GridRow>
    </CL.Grid>
  );
};
